import useSWR, { SWRConfiguration } from 'swr'
import { learningApi } from 'services/api'
import { toast } from 'react-toastify'

export function useGetRecentViewCourses(arrayCourseId: [string]) {
  const token = localStorage.getItem('token')

  const urls = arrayCourseId.map((c) => `/course/${c}/basic`)

  const key = token ? [urls, token] : null

  return useSWR(key, multiFetcher, configuration)
}

const multiFetcher = ([urls, token]: [string[], string]) => {
  const promises = urls.map(
    async (r) =>
      await learningApi
        .get(r, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data)
  )

  return Promise.all(promises)
}

const configuration: SWRConfiguration = {
  fallbackData: [],
  shouldRetryOnError: true,
  onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
    if (retryCount > 3) {
      toast.error('Não foi possível carregar o Visto Recentemente. Tente novamente mais tarde.')
    } else {
      setTimeout(() => revalidate({ retryCount }), 1000)
    }
  },
  keepPreviousData: true,
  dedupingInterval: 60e3,
  revalidateOnReconnect: true,
}
